import { runbookVersionService } from "../services/runbookVersion.service";
import { runbookVersionConstants } from "../constants/runbookVersion.constants";

export const runbookVersionActions = {
  get,
  create,
};

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookVersionService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return { type: runbookVersionConstants.GET_REQUEST, payload: requestParameters };
  }
  function success(paginatedResult) {
    return { type: runbookVersionConstants.GET_SUCCESS, payload: paginatedResult };
  }
  function failure() {
    return { type: runbookVersionConstants.GET_FAILURE };
  }
}

function create(requestBody) {
  return (dispatch) => {
    dispatch(request(requestBody));

    runbookVersionService.create(requestBody).then(
      (response) => {
        dispatch(success(response.data));
        // Refresh the list after creating
        dispatch(get({ runbookId: requestBody.runbookId, runbookGuid: requestBody.runbookGuid }));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(requestBody) {
    return { type: runbookVersionConstants.CREATE_REQUEST, payload: requestBody };
  }
  function success(response) {
    return { type: runbookVersionConstants.CREATE_SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: runbookVersionConstants.CREATE_FAILURE, payload: error };
  }
}
